function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Accordion } from "./components/accordion-main.js";
import classes from "./styles/accordions.module.scss.js";
var defaultAccordionState = {
  isDisabled: false,
  isOpen: false
};
/**
 * Base accordions.
 * Follows W3C ARIA practices: https://www.w3.org/TR/wai-aria-practices-1.2/#accordion.
 * W3C example: https://www.w3.org/TR/wai-aria-practices-1.2/examples/accordion/accordion.html.
 * @param {BaseAccordionProps} props BaseAccordionProps
 */
var BaseAccordion = function BaseAccordion(props) {
  var accordions = props.accordions,
    _props$allowMultipleE = props.allowMultipleExpanded,
    allowMultipleExpanded = _props$allowMultipleE === void 0 ? true : _props$allowMultipleE,
    _props$allowZeroExpan = props.allowZeroExpanded,
    allowZeroExpanded = _props$allowZeroExpan === void 0 ? false : _props$allowZeroExpan,
    animation = props.animation,
    changeToIndex = props.changeToIndex,
    id = props.id,
    initialActiveIndex = props.initialActiveIndex,
    _props$initialOpen = props.initialOpen,
    initialOpen = _props$initialOpen === void 0 ? true : _props$initialOpen,
    loading = props.loading,
    onChange = props.onChange,
    overrideAccordionsState = props.overrideAccordionsState,
    unmountOnExit = props.unmountOnExit;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    accordionsState = _useState2[0],
    setAccordionsState = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    focusIndex = _useState4[0],
    setFocusIndex = _useState4[1];
  var length = accordions.length;
  var zeroBasedLength = length - 1;
  var handleOpen = function handleOpen(isOpen, currentAccordions) {
    // if it's open and we allow no accordions open, close it
    if (isOpen && allowZeroExpanded) {
      return false;
    }
    // if it's open, there needs to be at least one other accordion open to close it
    if (isOpen && !allowZeroExpanded && currentAccordions.filter(function (accordion) {
      return accordion.isOpen;
    }).length < 2) {
      return true;
    }
    // else just toggle it
    return !isOpen;
  };
  var handleDisabled = function handleDisabled(isOpen, currentAccordions) {
    // if it's open, at least one accordion needs to be open to enable the accordion
    if (isOpen && !allowZeroExpanded && currentAccordions && currentAccordions.filter(function (accordion) {
      return accordion.isOpen;
    }).length < 2) {
      return true;
    }
    // if only one at a time and we don't allow all collapsed, disable the accordion
    // otherwise it will be false so the accordion is enabled
    return !allowMultipleExpanded && !allowZeroExpanded && isOpen;
  };
  var handleAccordionDisabled = function handleAccordionDisabled(accordion, currentAccordions) {
    return _objectSpread(_objectSpread({}, accordion), {}, {
      isDisabled: handleDisabled(accordion.isOpen, currentAccordions)
    });
  };
  var handleAccordionChange = function handleAccordionChange(index) {
    if (overrideAccordionsState) {
      // parent has decided to handle accordion state
      if (onChange) {
        onChange(index);
      }
      return;
    }
    // if only one at a time, close all other accordions, else make of copy of accordionsState
    var currentAccordions = allowMultipleExpanded ? _toConsumableArray(accordionsState) : accordionsState.map(function () {
      return _objectSpread({}, defaultAccordionState);
    });
    // copy the current accordion we are toggling and handle isOpen
    var currentAccordion = _objectSpread({}, accordionsState[index]);
    currentAccordion.isOpen = handleOpen(currentAccordion.isOpen, currentAccordions);
    currentAccordions[index] = currentAccordion;
    // IMPORTANT: we determine isDisabled after isOpen has been set on all accordions
    currentAccordions = currentAccordions.map(function (accordion) {
      return handleAccordionDisabled(accordion, currentAccordions);
    });
    setAccordionsState(currentAccordions);
    if (onChange) {
      onChange(index);
    }
  };
  /**
  * Handling up arrow, down arrow, spacebar, home, and end keys are required for accessibility compliance
  * https://www.w3.org/TR/wai-aria-practices-1.2/#keyboard-interaction
  */
  var handleAccordionKeyUp = function handleAccordionKeyUp(e, index) {
    // only handle accordion button keyboard events if we have more than one accordion
    if (length > 1) {
      // up arrow key focuses on the previous accordion button (or wraps around to the last)
      if (e.key === 'ArrowUp') {
        var prev = focusIndex === null ? -1 : focusIndex - 1;
        var prevIndex = prev < 0 ? zeroBasedLength : prev;
        setFocusIndex(prevIndex);
      }
      // down arrow key focuses on the next accordion button (or wraps around to the first)
      if (e.key === 'ArrowDown') {
        var next = focusIndex === null ? 1 : focusIndex + 1;
        var nextIndex = next > zeroBasedLength ? 0 : next;
        setFocusIndex(nextIndex);
      }
      // home focuses on the first accordion button
      if (e.key === 'Home') {
        setFocusIndex(0);
      }
      // end focuses on the last accordion button
      if (e.key === 'End') {
        setFocusIndex(zeroBasedLength);
      }
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        handleAccordionChange(index);
      }
    }
  };
  var handleInitialOpen = function handleInitialOpen(index) {
    // there are 3 conditions in which an accordion would be initially open on render:
    // 1. if we allow multiple accordions to be expanded and we start initially open
    var initialAllOpen = allowMultipleExpanded && initialOpen;
    // 2. if we have an initialActiveIndex, use that to determine whether the accordion should be open
    var isInitialActive = initialActiveIndex !== undefined && initialActiveIndex === index;
    // initialActiveIndex accordion is initially open if initialOpen is true or allowZeroExpanded is false
    var initialIndexOpen = isInitialActive && (!allowZeroExpanded || initialOpen);
    // 3. otherwise check if the first accordion should be open as a default
    var isFirstInitialActive = !initialActiveIndex && (!allowZeroExpanded || initialOpen) && index === 0;
    // set the first accordion open if we don't allow multiple accordions to be expanded
    // OR if it's the first accordion and we allow multiple accordions to be expanded but we don't allow all of them to be collapsed
    var initialFirstOpen = !allowMultipleExpanded && isFirstInitialActive || allowMultipleExpanded && !allowZeroExpanded && isFirstInitialActive;
    // NOTE: if initialAllOpen is true, initialIndexOpen and initialFirstOpen are intentionally ignored
    return initialAllOpen || initialIndexOpen || initialFirstOpen;
  };
  var handleInitialAccordionOpen = function handleInitialAccordionOpen(index) {
    return {
      isDisabled: false,
      isOpen: handleInitialOpen(index)
    };
  };
  var handleInitialAccordions = function handleInitialAccordions() {
    if (overrideAccordionsState) {
      // parent has decided to handle accordion state
      setAccordionsState(_toConsumableArray(overrideAccordionsState));
      return;
    }
    // we first initialize the accordions by setting isOpen on each accordion
    var initialAccordions = accordions.map(function (_, index) {
      return handleInitialAccordionOpen(index);
    });
    // then we set isDisabled on each accordion (IMPORTANT: we need to have initialAccordions before determining this)
    initialAccordions = initialAccordions.map(function (accordion) {
      return handleAccordionDisabled(accordion, initialAccordions);
    });
    setAccordionsState(initialAccordions);
  };
  // changing any of the booleans, the initialActiveIndex, or the number of accorions will cause the state to reset
  // this is for handling Storybook when one of the knobs are changed
  useEffect(function () {
    handleInitialAccordions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowMultipleExpanded, allowZeroExpanded, initialActiveIndex, initialOpen, accordions.length]);
  useEffect(function () {
    // let the parent component change the accordion (if it's a valid accordion)
    if (typeof changeToIndex === 'number' && changeToIndex >= 0 && changeToIndex < length) {
      handleAccordionChange(changeToIndex);
    }
  }, [changeToIndex]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (overrideAccordionsState) {
      setAccordionsState(_toConsumableArray(overrideAccordionsState));
    }
  }, [overrideAccordionsState]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordions
  }, accordions.map(function (accordion, index) {
    var _accordionsState$inde, _accordionsState$inde2;
    return /*#__PURE__*/React.createElement(Accordion, {
      key: "".concat(id, "-").concat(index),
      accordion: accordion,
      animation: animation,
      disabled: (_accordionsState$inde = accordionsState[index]) === null || _accordionsState$inde === void 0 ? void 0 : _accordionsState$inde.isDisabled,
      focusIndex: focusIndex,
      id: id,
      index: index,
      initialOpen: initialOpen,
      loading: loading,
      onChange: handleAccordionChange,
      onKeyUp: handleAccordionKeyUp,
      open: (_accordionsState$inde2 = accordionsState[index]) === null || _accordionsState$inde2 === void 0 ? void 0 : _accordionsState$inde2.isOpen,
      unmountOnExit: unmountOnExit
    });
  }));
};
export { BaseAccordion };